Vue.component('ack-tech-support-ticket', {
	delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
	template: '#ack-tech-support-ticket',
	mixins: [languageMixins],
	created() {},
	mounted() {},
	props: {
		// dataIn: {
		//   type: Object,
		//   required: true
		// }
	},
	computed: {
		//...Vuex.mapGetters('sliders', ['slidersLists']),
		//...Vuex.mapGetters('articles', ['articlesArray']),
		isMobile() {
			return this.$parent.isMobile;
		},
	},
	data() {
		return {
			pageId: 'tech-support-ticket-page',
		};
	},
	methods: {
		//...Vuex.mapActions('sliders', ['getSlideList'])
	},
	beforeDestroy() {},
	watch: {
		data1: {
			handler() {},
			deep: false,
		},
	},
});
